export default __webpack_public_path__ + "static/media/photo--sm--108.9cd26e86.jpg";